module.exports = __webpack_public_path__ + "assets/2adce49e7e3bd7985b2335849bc07ce7.svg";